import {apiSlice} from "../../app/apiSlice";

interface OpenIDConfiguration {
    provider: string,
    authorization_url: string
}

export interface UserProfile { name: string, permissions: string[], username: string, email:string, given_name?: string, family_name?: string }

const extendedApi = apiSlice.injectEndpoints({
    endpoints: (build => (
        {
            // getOpenIDConfiguration: build.query<OpenIDConfiguration[], void>({
            //     query: () => `/oauth/openid-configuration`,
            // }),
            // login: build.mutation<UserProfile, { username: string, password: string }>({
            //     query: (data) => ({url: `/login`, method: 'post', body: data}),
            // }),
            // exchangeOAuthCode: build.mutation<UserProfile, { code: string, provider: string }>({
            //     query: (data) => ({url: `/oauth`, method: 'post', body: data}),
            // }),

            profile: build.query<UserProfile, void>({
                query: () => `/profile`,
            }),
            logged: build.query<any, void>({
                query: () => `/logged`,
            }),
        }
    )),
    overrideExisting: false
})


export const {
    // useLoginMutation,
    useLazyProfileQuery,
    useProfileQuery,
    // useGetOpenIDConfigurationQuery
    useLoggedQuery
} = extendedApi